import { Outlet } from "react-router";
import t from "@/lang/lang";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageDescription,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import {
  TabsNav,
  TabsNavContent,
  TabsNavLink,
  TabsNavList,
} from "@/shared/components/layout/tabs-nav";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";

export function SamplesBaseDataRoute() {
  return (
    <PersistenceContextProvider>
      <BaseDataPage>
        <BaseDataPageHeader>
          <BaseDataPageTitle>{t("Labordaten")}</BaseDataPageTitle>
          <BaseDataPageDescription>
            {t(
              "Hier können die Labore und die Basisdaten für neue Proben konfiguriert werden.",
            )}
          </BaseDataPageDescription>
        </BaseDataPageHeader>
        <BaseDataPageContent>
          <TabsNav>
            <TabsNavList>
              <TabsNavLink to="labs">{t("Labore")}</TabsNavLink>
              <TabsNavLink to="air-microbial">
                {t("Luftkeimproben")}
              </TabsNavLink>
              <TabsNavLink to="surface-microbial">
                {t("Oberflächenkeimproben")}
              </TabsNavLink>
              <TabsNavLink to="dust-density">
                {t("Staubdichtemessungen")}
              </TabsNavLink>
              <TabsNavLink to="water">{t("Wasserproben")}</TabsNavLink>
            </TabsNavList>
            <TabsNavContent className="pt-2">
              <Outlet />
            </TabsNavContent>
          </TabsNav>
        </BaseDataPageContent>
      </BaseDataPage>
    </PersistenceContextProvider>
  );
}
